<template>
	<AsiDialogFormLayout :icon="icons.shipmentType" :title="$t('customer.defaultShipmentType')"
	                     :open="open" :loading="loading" :valid="valid" :errors="errors" @save="requestSave"
	                     @cancel="cancel" unwrapped scrollable>
		<v-card-text class="pa-6">
			<v-row>
				<v-col>
					<AsiRadioGroup v-model="model" :disabled="loading" class="ma-0 pa-0">
						<v-list class="pa-0">
							<v-list-item v-for="shipmentType in shipmentTypes" :key="shipmentType.id" @click="model = shipmentType.id">
								<v-list-item-action>
									<v-radio :value="shipmentType.id"/>
								</v-list-item-action>
								<v-list-item-content>
									<v-list-item-title>
										{{ shipmentTypeName(shipmentType) }}
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list>
					</AsiRadioGroup>
				</v-col>
			</v-row>
		</v-card-text>
	</AsiDialogFormLayout>
</template>

<script lang="ts">
	import {Component, Emit, Prop, Watch} from 'vue-property-decorator';
	import AsiAutocomplete from "@/components/common/AsiAutocomplete";
	import {ICustomerShop} from "@/models/customer/CustomerShopModels";
	import {ICustomerAdmin} from "@/models/customer/CustomerAdminModels";
	import {IShipmentTypeShop, IShipmentTypeShopListEntry} from "@/models/shipment-type/ShipmentTypeShopModels";
	import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
	import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";
	import Snackbar from "@/helpers/Snackbar";
	import AsiRadioGroup from "@/components/common/AsiRadioGroup";
	import TranslatedValueHelper from "@/models/translated-value/TranslatedValueHelper";

	@Component({
		components: {AsiRadioGroup, AsiAutocomplete, AsiDialogFormLayout}
	})
	export default class CustomerUpdateDefaultShipmentTypeDialog extends AsiDialogForm {

		@Prop({type: Object, required: true})
		public customer!: ICustomerShop

		private model: string | null = null;
		private shipmentTypes: IShipmentTypeShop[] | null = null;

		public mounted(): void {
			this.loadShipmentTypes();
			this.setCustomerInternal();
		}

		@Watch('customer', {deep: true})
		private onCustomerChanged(): void {
			this.setCustomerInternal();
		}

		private setCustomerInternal(): void {
			if (this.customer.defaultShipmentType?.id) {
				this.model = this.customer.defaultShipmentType.id;
			} else {
				this.model = null;
			}
			this.valid = true;
		}

		private shipmentTypeName(shipmentType: IShipmentTypeShopListEntry): string | null {
			return TranslatedValueHelper.get(shipmentType.name, this.$i18n.locale);
		}

		private requestSave(): void {
			if (this.model === null) return;
			this.loading = true;
			this.$customerServiceShop.setDefaultShipmentType(this.customer.id, this.model)
				.then(this.save)
				.catch(this.handleErrors)
				.finally(() => this.loading = false);
		}

		private loadShipmentTypes(): void {
			this.$shipmentTypeServiceShop.shipmentTypes(null, null)
				.then(data => this.shipmentTypes = data.data)
				.catch(() => Snackbar.loadingError());
		}

		@Emit('save')
		public save(): void {
			return;
		}

		@Emit('cancel')
		public cancel(): void {
			return;
		}
	}
</script>

<style scoped lang="scss">

</style>
